import React, { useEffect} from 'react';
import clsx from 'clsx';
import {
    checkExistDataElementName,
    checkIfEmpty,
    checkHasSpaces
} from '../../../validations/validations';
import {
    NameTextField
} from '../../../styling/Styles';
import RowElement from './RowElement';
import RadioMechanism from "../../GeneralComponents/RadioMechanism";

/**
 * @param {number} props.index - index of examined row that label component belongs inside data element
 * @param {[][]} props.typeFields - 2d array which contains for every row of a form the types of the inside components  
 * @param {setState} props.setTypeFields - hook method that handle typeFields variable
 * @param {[]} props.targets - page names of project
 * @param {[][]} props.components - 2d array  which contains for every row of a data element the inside components
 * @param {setState} props.setComponents - hook method that handle components variable 
 * @param {boolean} props.clickedDeleteElement - state that fires rerender of inside components when a component is added or deleted
 * @param {setState} props.setClickedDeleteElement - hook method tat handle clickedDeleteElement variable
 * @returns inside list element component with its options to update
 */
function TypeListElement(props){
  const {
    index,
    typeFields,
    setTypeFields,
    targets,
    components,
    setComponents,
    clickedDeleteElement,
    setClickedDeleteElement
  } = props;
  const [displayContent, setDisplayContent] = React.useState(false); // state that display/hide content of list data element
  const [imageSource, setImageSource] = React.useState(''); // image source of list data element
  const [titleText, setTitleText] = React.useState(''); // title of list data element
  const [descriptionText, setDescriptionText] = React.useState(''); // description of list data element
  const [hrefChecked, setHrefChecked] = React.useState(false) // state for href checkbox 
  const [targetPageChecked, setTargetPageChecked] = React.useState(false); // state for target page checkbox
  const [href, setHref] = React.useState(''); // value of href in checkbox
  const [target, setTarget] = React.useState('none'); // value of target page checkbox
  const [initListElement, setInitListElement] = React.useState(false) // state to init list element

  /**
   * It is runned to initialize list data element and it's options (href, target page, title text, description text and image source)
   * Also it runs every time that a row of list data element is deleted or added in order to rerender the other rows 
   */
  useEffect( () => {
    if(initListElement === false || clickedDeleteElement === true){

      setTitleText(components[index].titleText); 
      setDescriptionText(components[index].descriptionText); 
      setImageSource(components[index].imageSrc); 
      setHref(components[index].href);  
      setHrefChecked(components[index].hrefChecked); 
      setTargetPageChecked(components[index].targetPageChecked); 
      if(components[index].targetPage !== 'undefined' && components[index].targetPage !== ''){
        setTarget(components[index].targetPage); 
        setTargetPageChecked(true); 
        setHref('');
      }
      else{
          setTarget('none');
          setTargetPageChecked(false);
      }
      if(components[index].href !== ''  ){
          setHref(components[index].href);
          setHrefChecked(true);
          setTarget('none');
      }
      else if(components[index].targetPage === 'undefined' || components[index].targetPage === ''){
              setHrefChecked(true);
              setTarget('none');
      }
      else{
            setHrefChecked(false);
      }
      
      setInitListElement(true);
      setClickedDeleteElement(false);
    }
  },[initListElement,clickedDeleteElement])

  // Delete row of list data element method
  const deleteElement = () =>{
      const tempTypeFields = [...typeFields];
      tempTypeFields.splice(index,1);
      setTypeFields(tempTypeFields);

      const tempComponents = [...components];
      tempComponents.splice(index,1);
      setComponents(tempComponents);

      setClickedDeleteElement(true); // set clickedDeleteElement to true in order to rerender rows of list data element

  }

  // Handle image source of list element
  const handleImageSource = (val) => {
      setImageSource(val.target.value);
      const tempComponents = [...components];
      tempComponents[index].imageSrc = val.target.value;
      setComponents(tempComponents);
  }

  // Handle title text of list element
  const handleTitleText = (val) => {
      setTitleText(val.target.value);
      const tempComponents = [...components];
      tempComponents[index].titleText = val.target.value;
      setComponents(tempComponents);
  }

  // Handle description text of list element
  const handleDescriptionText = (val) => {
      setDescriptionText(val.target.value);
      const tempComponents = [...components];
      tempComponents[index].descriptionText = val.target.value;
      setComponents(tempComponents);
  }

  // Handle href checkbox status
  const handleHrefChecked = () => {
    const tempComponents = [...components];
    if(hrefChecked === false){
      setHrefChecked(true);
      setTargetPageChecked(false);
      tempComponents[index].hrefChecked = true;
      tempComponents[index].targetPageChecked = false;
      tempComponents[index].href = href;
      tempComponents[index].target_page = '';
    }
    else{
      setHrefChecked(false);
      tempComponents[index].href = '';
      tempComponents[index].hrefChecked = false; 
    }
    setComponents(tempComponents);
  }

  // Handle target page checkbox
  const handleTargetPageChecked = () => {
    const tempComponents = [...components];
    if(targetPageChecked === false){
      setTargetPageChecked(true);
      setHrefChecked(false);
      tempComponents[index].targetPageChecked = true;
      tempComponents[index].hrefChecked = false;
      tempComponents[index].href = '';
      tempComponents[index].target_page = target;
    }
    else{
      setTargetPageChecked(false);
      tempComponents[index].targetPageChecked = false;
      tempComponents[index].target_page = '';
    }
    setComponents(tempComponents);
  }

  // Handle value of href value
  const handleHref = (val) => {
    setHref(val.target.value);
    const tempComponents = [...components];
    setHrefChecked(true);
    setTargetPageChecked(false);
    tempComponents[index].href = val.target.value;
    tempComponents[index].target_page = 'undefined';
    setComponents(tempComponents);
  }

  // Handle value of target page value
  const selectTarget = (option) => {
    setTarget(option);
    const tempComponents = [...components];
    setTargetPageChecked(true);
    setHrefChecked(false);
    tempComponents[index].targetPage = option;
    tempComponents[index].href='';
    setComponents(tempComponents); 
  }

  return(
      <div style={{marginTop: '1vw'}}>
          <RowElement
            label={`List element ${(index+1)}`}
            displayContent={displayContent}
            setDisplayContent={setDisplayContent}
            deleteElement={deleteElement}
          />
          <div className={clsx('spacingTopDiv', 'spacingLeftDiv')} style={displayContent !== true ? {display: 'none'}: {display: 'inherit'} }>
            <div className={clsx('spacingLeftDiv','spacingTopDiv')}>
              <div>
                  Image source: &nbsp; <span style={{display: 'inline-block', marginLeft: '3.5vw' }}/>
                  <NameTextField
                      placeholder=' Image source'
                      onInput={e =>handleImageSource(e)}
                      value={imageSource}
                  />
              </div>
            </div>
            <RadioMechanism
              hrefChecked={hrefChecked}
              handleHrefChecked={handleHrefChecked}
              handleHref={handleHref}
              href={href}
              targetPageChecked={targetPageChecked}
              handleTargetPageChecked={handleTargetPageChecked}
              target={target}
              targets={targets}
              selectTarget={selectTarget}
              isEditList='true'
            />
            <div className={clsx('spacingLeftDiv','spacingTopDiv')}>
              <div>
                  Title text: &nbsp;<span style={{display: 'inline-block', marginLeft: '6.2vw' }}/>
                  <NameTextField
                      placeholder=' Title text'
                      onInput={e =>handleTitleText(e)}
                      value={titleText}
                  />
              </div>
            </div>
            <div className={clsx('spacingLeftDiv','spacingTopDiv')}>
              <div>
                  Description text: &nbsp;<span style={{display: 'inline-block', marginLeft: '2.9vw' }}/>
                  <NameTextField
                          placeholder= ' Description Text'
                          onInput={e => handleDescriptionText(e)}
                          value={descriptionText}
                          multiline
                          rows={3}
                  />
              </div>
            </div>
          </div>
      </div>
  )


}

const ListDataElement = (props) =>{

    const{
        selectedProject,
        clickedEditBlockDataElement,
        dataListName,
        setDataListName,
        indexEditBlockDataElement,
        clickedList,
        editor,
        clickedGenerateBlock,
        setClickedGenerateBlock,
        components,
        setComponents,
        typeFields,
        setTypeFields,
        savedPageClicked
    } = props;
    const [targets,setTargets] = React.useState([]);
    const handleDataNameInput = (val) => {
        setDataListName(val.target.value);
    }
    const [clickedDeleteElement, setClickedDeleteElement] = React.useState(false);
    const [finisProductDataElement, setFinishProductDataElement] = React.useState(false);

    useEffect( () => {
        if(clickedList === true || clickedEditBlockDataElement === true ){
          if( clickedEditBlockDataElement !== true){
              setDataListName('ListName');
          }
          const tempData = JSON.parse(localStorage.getItem('data'))[selectedProject];
          const tempTargets = [];
          tempData.pages.forEach( (page) => {
            tempTargets.push(page.name);
          })
          setTargets(tempTargets);
          setFinishProductDataElement(false);
        }
    },[clickedList, clickedEditBlockDataElement])

    useEffect( () => {

      if(finisProductDataElement === true){
        savedPageClicked();
      }
  
    },[finisProductDataElement])

    useEffect( () => {
      if(clickedGenerateBlock === true){
        setClickedGenerateBlock(false);
        
        if( checkIfEmpty(dataListName) === false && checkHasSpaces(dataListName) === false && checkExistDataElementName(dataListName,selectedProject,indexEditBlockDataElement) === false){
          const tempContent = [];
          
          components.forEach( (component) => {

            let tempImageAttributes = {};
            if(component.hrefChecked === true){
              tempImageAttributes ={
                src: component.imageSrc,
                alt: "Image",
                href: component.href
              }
            }
            else if(component.targetPageChecked === true){
              tempImageAttributes ={
                src: component.imageSrc,
                alt: "Image",
                target_page: component.targetPage
              }
            }
            else{
              tempImageAttributes ={
                src: component.imageSrc,
                alt: "Image",
              }
            }

            tempContent.push({  
              type: 'row',
              tagName: 'tr',
              components: [
                  {
                    type: 'cell', 
                    tagName: 'td',
                    components: [
                      {   
                          type: 'image', 
                          attributes: tempImageAttributes,
                          classes: ["list-item-image"],
                      }
                    ],
                    classes: ['list-cell-left']
                  },
                  {
                    type: 'cell', 
                    tagName: 'td',
                    components: [
                      {tagName: 'h1', content: component.titleText, classes:['card-title']},
                      {tagName: 'p', content: component.descriptionText, classes:['card-text']},
                      ],
                    classes: ['list-cell-right']
                    },
              ],
              
              classes: ["list-item-content"]
            
            })

            
          })

          const tempTableContent = {
            type: 'tableList',   
            components:[{
              type: 'tbody',
              components: tempContent
            }], 
            attributes:{
              wabliname: dataListName,
              wablitype: 'list'
            }
          }

          editor.BlockManager.add(dataListName,{
            label: `${dataListName}Block`,
            content: tempTableContent,
            category: {
                label: 'Extra ',
                open: 'false',
            },
          });

          const tempData = JSON.parse(localStorage.getItem('data'))
          const tempDataElementBlock = {
              'id': dataListName,
              'content': tempTableContent,
              'label': `${dataListName} Block`,
              'category': {
                  label: 'Extra ',
                  open: 'false',
              }
          }

          const tempDataElementInfo = {
              'typeFields': typeFields,
              'dataName': dataListName,
               'components': components,
               'type': 'list'
          }

          if(clickedEditBlockDataElement === true){
              tempData[selectedProject].data_elements.data_elements_blocks[indexEditBlockDataElement].blocks[0] =tempDataElementBlock;
              tempData[selectedProject].data_elements.data_elements_info[indexEditBlockDataElement]=tempDataElementInfo;
          }
          else{
              tempData[selectedProject].data_elements.data_elements_blocks.push({blocks: [tempDataElementBlock]})
              tempData[selectedProject].data_elements.data_elements_info.push(tempDataElementInfo)
              
          }
          localStorage.setItem('data',JSON.stringify(tempData));    
        }
        setFinishProductDataElement(true);
      }

    },[clickedGenerateBlock])

  
    const addListElement = () => {
      const tempTypeFields = [...typeFields];
      tempTypeFields.push('listElement');
      setTypeFields(tempTypeFields);

      const tempComponents = [...components];
      tempComponents.push({
        imageSrc: '',
        href: '',
        hrefChecked: false,
        targetPageChecked: false,
        targetPage: '',
        titleText: '',
        descriptionText: ''
      })
      setComponents(tempComponents);
    }

    const getHelperText = () => {
      if( checkIfEmpty(dataListName) === true ){
        return "List name empty";
      }
      if( checkHasSpaces(dataListName) === true){
        return "Spaces are not allowed";
      }
      if( checkExistDataElementName(dataListName,selectedProject,indexEditBlockDataElement) === true){
        return "Name already exists";
      }
      return "";
    }

    return(
            <div style={{marginTop: '1vw'}} >
                <div className={clsx('flexRowDirection')}>
                    <span>Name of list: &nbsp;</span>
                    {clickedEditBlockDataElement !== true ?
                        <NameTextField
                            id='DataListName'
                            placeholder=' Name of list data'
                            onInput={e =>handleDataNameInput(e)}
                            value={dataListName}
                            error = {checkIfEmpty(dataListName) === true || checkHasSpaces(dataListName) === true || checkExistDataElementName(dataListName,selectedProject,indexEditBlockDataElement) === true}
                            helperText={ getHelperText()}
                        />
                        :
                        <span>{dataListName} </span>
                        }
                </div>
                <div style={{marginTop : '1vw'}}>
                    {
                        typeFields.map( (type,index) => 
                            
                            type === 'listElement'?
                                <TypeListElement
                                    index={index}
                                    typeFields={typeFields}
                                    setTypeFields={setTypeFields}
                                    targets={targets}
                                    components={components}
                                    setComponents={setComponents}
                                    clickedDeleteElement={clickedDeleteElement}
                                    setClickedDeleteElement={setClickedDeleteElement}
                                />
                                :
                                null
                        ) 
                    }
                </div>
                <span 
                        className={clsx('teamSelector', 'spacingDownDiv','spacingTopDiv')} 
                        onClick={() => addListElement()}
                        aria-hidden="true"
                        style={{ display: 'inline-block'}}
                    >
                        <span 
                        style={{fontSize: '0.7vw'}}
                        className={clsx('lightBlue')}>
                            Add new list element &nbsp;
                        </span>
                      
                    </span>
            </div>
    )
}

export default ListDataElement;